import React from "react";
import {
  FaPalette,
  FaFileContract,
  FaLink,
  FaStore,
  FaCrown,
  FaShieldAlt
} from "react-icons/fa";

function CustomNFTDesign() {
  return (
    <>
      <div className="services-style-two-area default-padding bg-gray blurry-shape-right-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">What we do</h4>
                <h2 className="title split-text-right split-text-in-right">
                  Key Aspects of our NFT Collection Launch Service
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className=" fade-up-anim ">
            <div className="row">

              <div className="col-lg-4 col-md-6 process-two-single">
                <div className="services-style-two-item">
                  <div className="top-info">
                    <FaPalette className=" text-black mb-3" size={35} />
                    <h4>
                      <a>Custom NFT Design & Creation</a>
                    </h4>
                    <p>
                      From concept to creation, our team helps you develop
                      visually stunning and one-of-a-kind NFTs tailored to your
                      project’s theme and goals.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 process-two-single">
                <div className="services-style-two-item fade-up-anim">
                  <div className="top-info">
                    <FaFileContract className=" text-black mb-3" size={35} />
                    <h4>
                      <a>Smart Contract Development</a>
                    </h4>
                    <p>
                      We create secure and efficient smart contracts that govern
                      the minting, ownership transfer, and royalties for your
                      NFT collection, ensuring transparency and trust.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 process-two-single">
                <div className="services-style-two-item fade-up-anim">
                  <div className="top-info">
                    <FaLink className=" text-black mb-3" size={35} />
                    <h4>
                      <a>Blockchain Integration</a>
                    </h4>
                    <p>
                      We offer multi-chain support, allowing you to choose from
                      top blockchain networks like Ethereum, Solana, Binance
                      Smart Chain, and more for launching your NFT collection.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 process-two-single pt-4">
                <div className="services-style-two-item">
                  <div className="top-info">
                    <FaStore className=" text-black mb-3" size={35} />
                    <h4>
                      <a>Marketplace Listing & Launch Strategy</a>
                    </h4>
                    <p>
                      We assist you in listing your NFTs on popular marketplaces
                      such as OpenSea, Rarible, and Foundation or help you build
                      a custom marketplace.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 process-two-single pt-4">
                <div className="services-style-two-item fade-up-anim">
                  <div className="top-info">
                    <FaCrown className=" text-black mb-3" size={35} />
                    <h4>
                      <a>Royalty Management</a>
                    </h4>
                    <p>
                      Automate royalty payments for secondary sales, ensuring
                      you benefit from the continued success of your NFTs as
                      they are bought and sold on the market.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 process-two-single pt-4">
                <div className="services-style-two-item fade-up-anim">
                  <div className="top-info">
                    <FaShieldAlt className=" text-black mb-3" size={35} />
                    <h4>
                      <a>Security & Scalability</a>
                    </h4>
                    <p>
                      We prioritize the security of your collection with
                      rigorous audits and encryption, while ensuring scalability
                      to support high traffic during your launch.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CustomNFTDesign;